import { apiGet, apiPost, apiCall } from './apiUtils';

/**
 * Admin Task Service for React Website
 * Handles admin task operations including welcome calls
 */

const adminTaskService = {
  /**
   * Get welcome call tasks
   * @returns {Promise<Object>} Welcome call tasks data
   */
  getWelcomeCallTasks: async () => {
    try {
      console.log('📞 Fetching welcome call tasks');
      const response = await apiGet('admin/welcome-tasks', {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Welcome call tasks response:', response);
      return response;
    } catch (error) {
      console.error('Error fetching welcome call tasks:', error);
      throw error;
    }
  },

  /**
   * Claim a task
   * @param {number} taskId - Task ID to claim
   * @returns {Promise<Object>} Claim response
   */
  claimTask: async (taskId) => {
    try {
      console.log('✋ Claiming task:', taskId);
      const response = await apiPost(`admin/welcome-tasks/${taskId}/claim`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Claim task response:', response);
      return response;
    } catch (error) {
      console.error('Error claiming task:', error);
      throw error;
    }
  },

  /**
   * Complete a task with feedback
   * @param {number} taskId - Task ID to complete
   * @param {string} feedback - Feedback text
   * @returns {Promise<Object>} Complete response
   */
  completeTask: async (taskId, feedback) => {
    try {
      console.log('✅ Completing task:', taskId, 'with feedback:', feedback);
      const response = await apiPost(`admin/welcome-tasks/${taskId}/complete`, {
        feedback: feedback
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Complete task response:', response);
      return response;
    } catch (error) {
      console.error('Error completing task:', error);
      throw error;
    }
  },

  /**
   * Create scheduled task
   * @param {Object} taskData - Task data
   * @returns {Promise<Object>} Create response
   */
  createScheduledTask: async (taskData) => {
    try {
      console.log('📅 Creating scheduled task:', taskData);
      const response = await apiPost('admin/welcome-tasks/schedule', taskData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Create scheduled task response:', response);
      return response;
    } catch (error) {
      console.error('Error creating scheduled task:', error);
      throw error;
    }
  }
};

export default adminTaskService;